import { adminApi } from "../../lib/axios";

export interface AiSearchUsageRow {
  brandId: string;
  brandName: string;
  email: string;
  monthKey: string;
  planName: string;
  base: number;
  extended: number;
  purchased: number;
  used: number;
  remaining: number;
}

export interface AiSearchUsageResponse {
  monthKey: string;
  data: AiSearchUsageRow[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ExtendCreditsPayload {
  brandId: string;
  extraCredits: number;
  note?: string;
}

export interface ExtendCreditsResponse {
  extension: {
    id: string;
    brandId: string;
    monthKey: string;
    extraCredits: number;
    note: string | null;
    createdAt: string;
  };
  credits: {
    planName: string;
    base: number;
    extended: number;
    purchased: number;
    used: number;
    remaining: number;
    total: number;
    monthKey: string;
  };
}

export const aiSearchAdminService = {
  async getUsage(params: {
    page?: number;
    limit?: number;
    monthKey?: string;
  }): Promise<AiSearchUsageResponse> {
    const response = await adminApi.get<AiSearchUsageResponse>(
      "/ai-search/admin/usage",
      { params }
    );
    return response.data;
  },

  async extendCredits(
    payload: ExtendCreditsPayload
  ): Promise<ExtendCreditsResponse> {
    const response = await adminApi.post<ExtendCreditsResponse>(
      "/ai-search/admin/credits/extend",
      payload
    );
    return response.data;
  },
};
